import { default as ReactSelect } from "react-select";
import { options } from "./data";
import { customStyles } from "./customStyles";
import { Option } from "./customComponent";
import "./multiselect.css";

const MultiSelectDropdown = ({ setPlayingTime, typeOfInfoError }) => {
  return (
    <ReactSelect
      options={options}
      styles={customStyles}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      components={{
        Option,
      }}
      onChange={setPlayingTime}
      allowSelectAll={true}
      typeOfInfoError={typeOfInfoError}
    />
  );
};

export default MultiSelectDropdown;
